"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMeta = buildMeta;
exports.findHasSection = findHasSection;
exports.findParentPath = findParentPath;
exports.createUniqueCrumbs = createUniqueCrumbs;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// build metadata for each page
function buildMeta(frontMatter, pathname, navigation) {
  var hasSection = findHasSection(navigation, pathname);
  var subsite = frontMatter.subsite || hasSection ? hasSection.title : undefined;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    pathname: pathname
  }, frontMatter.title && {
    title: frontMatter.title
  }), frontMatter.description && {
    description: frontMatter.description
  }), frontMatter.contentType && {
    contentType: frontMatter.contentType
  }), frontMatter.language && {
    language: frontMatter.language
  }), frontMatter.level && {
    level: frontMatter.level
  }), subsite && {
    subsite: subsite
  }), frontMatter.hideFromSearchEngines && {
    hideFromSearchEngines: frontMatter.hideFromSearchEngines
  });
}

function findHasSection(navigation, pathname) {
  if (!navigation || !pathname) return;
  return navigation.hierarchy && navigation.hierarchy[pathname] && navigation.hierarchy[pathname].section ? navigation.hierarchy[pathname].section : undefined;
}

function findParentPath(navigation, pathname) {
  if (!navigation || !pathname) return;
  return navigation.hierarchy && navigation.hierarchy[pathname] && navigation.hierarchy[pathname].parent ? navigation.hierarchy[pathname].parent : undefined;
} // cleans breadcrumbs
// does not add a link if the path or title already exists


function createUniqueCrumbs(links) {
  return links.reduce(function (arr, item) {
    var pathExists = arr.filter(function (f) {
      return f.path === item.path;
    }).length > 0;
    var titleExists = arr.filter(function (f) {
      return f.title === item.title;
    }).length > 0;
    if (!pathExists && !titleExists) arr.push(item);
    return arr;
  }, []);
}